import { defineAsyncComponent } from 'vue';

import { mountApp } from '@/helpers/vueAppRegistry';

export default function initDocumentDownloadApproval() {
    mountApp(
        defineAsyncComponent(() => import('./DocumentDownloadApproval.vue')),
        '#app-document-download-approval',
        {},
        true
    );
}
